import Grid from "@mui/material/Grid";
import { RenderInputByTypeMobile } from "../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { MultiAutocomplete } from "../../../components/multiAutocomplete/MultiAutocomplete";
import { TextInput } from "../../../components/textInput/TextInput";
import { getLastYearsList } from "../../../utils/helpers";
import { mesesEnum } from "../../MisVisitas/constants";

const mesesOptions = mesesEnum.map(x => ({ id: x.value, displayName: x.name }));
const aniosOptions = getLastYearsList(8).map(year => ({ id: year, displayName: year.toString() }));

export const PreLiquidacionFilters = ({
    filters,
    handleChangeFilters,
    handleSearch,
    delegacionesOptions,
    profesionalesOptions,
    estadosOptions,
    tiposProfesionalOptions
}) => {
    return (
        <Grid container spacing={1.5} alignItems="center" marginBottom={3} columns={100}>
            <Grid size={{ xs: 100, sm: 67, md: 14 }}>
                <TextInput
                    placeholder='Filtrar'
                    value={filters.filtrar}
                    searchIcon
                    onChange={(event) => handleChangeFilters('filtrar', event.target.value)}
                    onClearButtonClick={() => handleChangeFilters('filtrar', '')}
                />
            </Grid>
            <Grid size={{ xs: 100, sm: 33, md: 9 }}>
                <RenderInputByTypeMobile
                    input={{
                        displayName: "Mes",
                        name: "mes",
                        type: "select",
                        options: mesesOptions
                    }}
                    handleChange={handleChangeFilters}
                    value={filters.mes}
                />
            </Grid>
            <Grid size={{ xs: 100, sm: 33, md: 8 }}>
                <RenderInputByTypeMobile
                    input={{
                        displayName: "Año",
                        name: "anio",
                        type: "select",
                        options: aniosOptions
                    }}
                    handleChange={handleChangeFilters}
                    value={filters.anio}
                />
            </Grid>
            <Grid size={{ xs: 100, sm: 33, md: 13 }}>
                <RenderInputByTypeMobile
                    input={{
                        displayName: "Tipo Profesional",
                        name: "idTipoProfesional",
                        type: "select",
                        options: tiposProfesionalOptions
                    }}
                    handleChange={handleChangeFilters}
                    value={filters.idTipoProfesional}
                />
            </Grid>
            <Grid size={{ xs: 100, sm: 33, md: 15 }}>
                <RenderInputByTypeMobile
                    input={{
                        displayName: "Delegación",
                        name: "idDelegacion",
                        type: "select",
                        options: delegacionesOptions
                    }}
                    handleChange={handleChangeFilters}
                    value={filters.idDelegacion}
                />
            </Grid>
            <Grid size={{ xs: 100, sm: 33, md: 19 }}>
                <MultiAutocomplete
                    label="Profesionales"
                    name="idsProfesionales"
                    options={profesionalesOptions}
                    value={filters.idsProfesionales || []}
                    onChange={handleChangeFilters}
                    disabled={!filters.idTipoProfesional || !filters.idDelegacion}
                />
            </Grid>
            <Grid size={{ xs: 100, sm: 33, md: 14 }}>
                <RenderInputByTypeMobile
                    input={{
                        displayName: "Estado",
                        name: "idEstado",
                        type: "select",
                        options: estadosOptions
                    }}
                    handleChange={handleChangeFilters}
                    value={filters.idEstado}
                />
            </Grid>
            <Grid size={{ xs: 100, sm: 33, md: 8 }}>
                <RenderInputByTypeMobile
                    input={{
                        displayName: "Buscar",
                        name: "buscarButton",
                        type: "button",
                        onClick: handleSearch,
                        variant: "outlined"
                    }}
                />
            </Grid>
        </Grid>
    )
}